export const discourseDocumentItemType = {
	sickLeave: 'discourseSickLeave',
	discourseTravel: 'discourseTravel',
} as const;

export const NOT_ALLOWED_ATTACHMENTS = [
	'content',
	'name',
	'datetime',
	'diagnosis',
	'secondaryDiagnosis',
	'fileId',
	'title',
	'case',
	discourseDocumentItemType.sickLeave,
	discourseDocumentItemType.discourseTravel,
] as const;
